import { LocalStorageValue } from './LocalStorageValue'

export class ObjectLocalStorageValue<T> extends LocalStorageValue<T> {
  constructor(key: string, defaultValue?: T) {
    super(
      key,
      (value: T) => JSON.stringify(value),
      (serializedStr: string) => JSON.parse(serializedStr) as T,
      defaultValue,
    )
  }
}
